import { Box, Skeleton, Stack } from '@mui/material';

const ViolationNoteSkeleton = () => {
  return (
    <Stack spacing={2}>
      {[1, 2, 3].map((index) => (
        <Box
          key={index}
          sx={{
            borderBottom: 1,
            borderColor: 'divider',
            p: 2,
            borderRadius: 1,
          }}
        >
          {/* Date */}
          <Skeleton width={100} height={16} sx={{ mb: 1 }} />

          {/* Author */}
          <Skeleton width={150} height={20} sx={{ mb: 1 }} />

          {/* Comment */}
          <Skeleton width="95%" height={16} sx={{ mb: 0.5 }} />
          <Skeleton width="80%" height={16} />
        </Box>
      ))}
    </Stack>
  );
};

export default ViolationNoteSkeleton;
